import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs, withDefaults } from 'vue'

  import Error from '@/components/Common/Error.vue'
  interface Props {
    target?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    target: { default: 'PAGE' }
  },
  setup(__props: any) {

const props = __props as { target: string }

  
  const { target } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Error, {
    title: "404",
    message: _ctx.$t(`error.NOT_FOUND.${_unref(target)}`),
    "button-text": _ctx.$t('common.HOME')
  }, null, 8, ["message", "button-text"]))
}
}

})